import { CSSObject, Theme, forBrands } from '@core-ui/react-stitch';

const setMenuStylesForBananaRepublic = (theme: Theme): CSSObject => ({
  backgroundColor: theme.color.inverse.b1,
  boxShadow: 'none',
  width: '6.25rem',
  '&[aria-activedescendant]': {
    border: `0.063rem solid ${theme.color.b2}`,
  },
});

const getMenuStyles =
  () =>
  (base: CSSObject, { theme }: { theme: Theme }): CSSObject => ({
    ...base,
    ...(forBrands(theme, {
      br: setMenuStylesForBananaRepublic,
      brfs: setMenuStylesForBananaRepublic,
    }) as CSSObject),
  });

export default getMenuStyles;
